import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'normalizeDecimal',
  standalone: false,
})
export class NormalizeDecimalPipe implements PipeTransform {
  transform(value: any): any {
    if (typeof value === 'string') {
      let normalized = String(value).replace(/,/g, '')
      normalized = isNaN(parseFloat(normalized)) ? '0' : normalized
      return normalized
    } else {
      return value
    }
  }
}
